module.exports = __webpack_public_path__ + "images/flag_icon.png";